export const WHATSAPP_NUMBER = "5513955436075";
export const PHONE_FIXED = "(13) 4042-0111";
export const PHONE_FIXED_TEL = "tel:+551340420111";
export const PHONE_WHATSAPP = "(13) 95543-6075";
export const PHONE_ADDITIONAL = "(13) 98189-7777";
export const PHONE_ADDITIONAL_TEL = "tel:+5513981897777";
export const EMAIL = "Tmzchinho@tomizo.log";
export const ADDRESS_LINE1 = "Rodovia Régis Bittencourt, km 377";
export const ADDRESS_LINE2 = "Miracatu – SP, CEP 11850-000";

export const waLink = (text) =>
    `https://wa.me/${WHATSAPP_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const WA_MAIN = waLink();
export const WA_CONFORT = waLink("Olá, gostaria de saber mais sobre o Plano Confort.");
export const WA_REVIEW = waLink("Olá, gostaria de avaliar o atendimento.");
export const WA_RESCUE = waLink("Olá, preciso de guincho de plataforma. Podem me ajudar?");

export const IMAGES = {
    heroTruck: "/assets/hero-caminhao-tomizo.jpg",
    aboutMission:
        "https://images.unsplash.com/photo-1738101996177-13110d20a973?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHx0b3clMjB0cnVjayUyMG9wZXJhdG9yJTIwc2VjdXJpbmd8ZW58MHx8fHwxNzkyMTUzNTY0fDA&ixlib=rb-4.1.0&q=85",
    serviceFlatbed:
        "https://images.unsplash.com/photo-1686966933735-305bd8fe0a77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxmbGF0YmVkJTIwdG93JTIwdHJ1Y2slMjB0cmFuc3BvcnRpbmclMjBjYXJ8ZW58MHx8fHwxNzkyMTUzNTY0fDA&ixlib=rb-4.1.0&q=85",
    serviceAsdelta:
        "https://images.unsplash.com/photo-1730514785075-b065c757b653?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxmbGF0YmVkJTIwdG93JTIwdHJ1Y2slMjB0cmFuc3BvcnRpbmclMjBjYXJ8ZW58MHx8fHwxNzkyMTUzNTY0fDA&ixlib=rb-4.1.0&q=85",
    planoConfort:
        "https://images.pexels.com/photos/21012245/pexels-photo-21012245.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    clientSatisfaction:
        "https://images.unsplash.com/photo-1530065928592-fb0dc85d2f27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxmYW1pbHklMjBwYXNzZW5nZXIlMjBjYXIlMjBjb21mb3J0fGVufDB8fHx8MTc5MjE1MzU2NHww&ixlib=rb-4.1.0&q=85",
};

export const MAP_EMBED =
    "https://maps.google.com/maps?q=Rodovia%20R%C3%A9gis%20Bittencourt%2C%20km%20377%2C%20Miracatu%20-%20SP%2C%2011850-000&t=&z=13&ie=UTF8&iwloc=&output=embed";
